import React from 'react';
import PropTypes from 'prop-types';

import UserInfoCard from './UserInfoCard';
import InfoRow from './InfoRow';
import Paper from '../Paper';

function UserInfoBlock({
  list,
  onClick,
  disabled,
  avatarUrl,
  className,
  avatarSize,
  avatarText,
  buttonText,
  buttonColor,
  textPrimary,
  textComplementary,
}) {
  return (
    <Paper className={className}>
      <UserInfoCard
        onClick={onClick}
        disabled={disabled}
        avatarUrl={avatarUrl}
        avatarSize={avatarSize}
        avatarText={avatarText}
        buttonText={buttonText}
        buttonColor={buttonColor}
        textPrimary={textPrimary}
        textComplementary={textComplementary}
      />
      <InfoRow list={list} />
    </Paper>
  );
}

UserInfoBlock.propTypes = {
  list: PropTypes.array,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  avatarUrl: PropTypes.string,
  avatarSize: PropTypes.number,
  avatarText: PropTypes.string,
  buttonText: PropTypes.string,
  buttonColor: PropTypes.string,
  textPrimary: PropTypes.string,
  textComplementary: PropTypes.string,
};

export default UserInfoBlock;



// WEBPACK FOOTER //
// ./src/components/UserInfoBlock/index.jsx